import { db } from "@/fstore";
import axios from "axios";
import { areUploadCredentialsValid } from "@/utils/uploadCredentials";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    updateCredentialsIfNeeded({ dispatch }, show_obj) {
      console.log("editor/updateCredentialsIfNeeded", show_obj.key);
      if (areUploadCredentialsValid(show_obj)) {
        return true;
      }
      dispatch("editor/updateCredentialsByKey", show_obj.key, { root: true });
    },
    updateCredentialsByKey({ rootState }, key) {
      // Called when new show is created.
      console.log(rootState);
      console.log("editor/updateCredentials", key);
      var policyUpdateEndpoint =
        "https://upload.soundslides.com/editor/policy/update/" + key + "/";
      //policyUpdateEndpoint = "http://127.0.0.1:5000/editor/policy/update/" + state.currentShowId + "/";
      axios.get(policyUpdateEndpoint).then(function(e) {
        console.log(e);
        console.log("editor/updateCredentialsByKey, success");
      });
    },
    updateShowData({ rootState }, show_object) {
      // This is only used by showImportFromZip conponents.
      // Use the show version everywhere else.
      console.log(rootState);
      console.log("editor/updateShowData");
      // Note, the show_object only needs to contain the fields that you want updated.
      var show_key = show_object.key;
      var updated_at = new Date().getTime();
      // Update on server.
      show_object.updated_at = updated_at;
      db.collection("editor_shows")
        .doc(show_key)
        .update(show_object)
        .then(function() {
          console.log("editor/updateShowData", "success");
        });
    }
  }
};
